export var NavbarCssClass;
(function (NavbarCssClass) {
    NavbarCssClass["ContentWrapper"] = "iress-navbar__content";
    NavbarCssClass["Base"] = "iress-navbar";
    NavbarCssClass["Breakpoint"] = "iress-navbar--breakpoint";
    NavbarCssClass["Fixed"] = "iress-navbar--fixed";
    NavbarCssClass["ToggleButton"] = "iress-navbar__toggle-button";
    NavbarCssClass["LogoIcon"] = "iress-navbar__logo-icon";
    NavbarCssClass["LogoImage"] = "iress-navbar__logo-image";
    NavbarCssClass["LogoLink"] = "iress-navbar__logo-link";
    NavbarCssClass["Panel"] = "iress-navbar__panel";
})(NavbarCssClass || (NavbarCssClass = {}));
export var NavbarSlot;
(function (NavbarSlot) {
    NavbarSlot["Logo"] = "logo";
    NavbarSlot["Nav"] = "nav";
})(NavbarSlot || (NavbarSlot = {}));
export var NavbarHorizontalAlign;
(function (NavbarHorizontalAlign) {
    NavbarHorizontalAlign["Between"] = "between";
    NavbarHorizontalAlign["End"] = "end";
    NavbarHorizontalAlign["Start"] = "start";
})(NavbarHorizontalAlign || (NavbarHorizontalAlign = {}));
//# sourceMappingURL=navbar.types.js.map